"use client";

import { CircleFadingArrowUp } from "lucide-react";
import posthog from "posthog-js";
import usePricingModal, { PAYWALL_TYPES } from "@/lib/hooks/use-pricing-modal";
import { cn } from "@/lib/utils";
import { useI18n } from "@/locales/client";
import { useAuth } from "../providers/auth-context";
import { SidebarMenuButton } from "../ui/sidebar";

const UpgradeButton = () => {
  const { onOpen } = usePricingModal();
  const { userId } = useAuth();
  const t = useI18n();
  return (
    <SidebarMenuButton
      onClick={() => {
        onOpen({
          paywallType: PAYWALL_TYPES.SIDEBAR_UPGRADE_BUTTON,
        });
        posthog.capture("paywall_shown", {
          userId,
          paywallType: PAYWALL_TYPES.SIDEBAR_UPGRADE_BUTTON,
        });
      }}
      tooltip={"Upgrade"}
      className={cn(
        "flex group-data-[collapsible=icon]:justify-start justify-center bg-brand-primary focus-visible:bg-brand-primary active:bg-brand-primary active:text-white focus:bg-brand-primary text-primary-foreground border-brand-primary hover:bg-brand-primary hover:text-white h-9",
      )}
    >
      <CircleFadingArrowUp className="size-4" />
      <span>{t("upgrade")}</span>
    </SidebarMenuButton>
  );
};

export default UpgradeButton;
